import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeaveBalanceComponent } from './leave-balance.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LeaveBalanceComponent],
  exports: [LeaveBalanceComponent]
})
export class LeaveBalanceDetailsModule { }



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/leave-balance-details/leave-balance-details.module.ts